import { cn } from '../lib/utils';

export interface LanguageOption {
  code: string;
  nativeLabel: string;
  label: string;
}

const DEFAULT_LANGUAGES: LanguageOption[] = [
  { code: 'en', nativeLabel: 'English', label: 'English' },
  { code: 'hi', nativeLabel: 'हिन्दी', label: 'Hindi' },
  { code: 'te', nativeLabel: 'తెలుగు', label: 'Telugu' },
  { code: 'ta', nativeLabel: 'தமிழ்', label: 'Tamil' },
  { code: 'gu', nativeLabel: 'ગુજરાતી', label: 'Gujarati' },
  { code: 'pa', nativeLabel: 'ਪੰਜਾਬੀ', label: 'Punjabi' },
];

export interface LanguagePickerProps {
  currentLanguage: string;
  onLanguageChange: (code: string) => void;
  languages?: LanguageOption[];
  className?: string;
}

export function LanguagePicker({
  currentLanguage,
  onLanguageChange,
  languages = DEFAULT_LANGUAGES,
  className,
}: LanguagePickerProps) {

  return (
    <div className={cn('relative inline-block', className)}>
      <select
        value={currentLanguage}
        onChange={(e) => onLanguageChange(e.target.value)}
        aria-label="Select language"
        className={cn(
          'appearance-none cursor-pointer rounded-md border border-input bg-background px-3 py-1.5',
          'text-sm font-medium text-foreground shadow-sm',
          'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1',
          'hover:bg-accent/50 transition-colors duration-150',
          'pr-8',
        )}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.nativeLabel}
          </option>
        ))}
      </select>
      {/* Custom dropdown arrow */}
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground text-xs">
        ▾
      </span>
    </div>
  );
}

export type { LanguagePickerProps as LanguagePickerComponentProps };
